module.exports = __webpack_public_path__ + "img/symptom_new.a3d0c1c5.png";